import { resolveDestinationTimeZone } from "./destinationTimeZones";
type Row = Record<string, unknown>;
const object = (value: unknown): Row => value && typeof value === "object" ? value as Row : {};
export function shareTimeContext(trip: Row, snapshot: Row): { countryCode: string; destinationTimeZone: string } {
  const places = Array.isArray(snapshot.places) ? snapshot.places.map(object) : [];
  const countries = [...new Set(places.map(place => String(place.countryCode || String(place.address || "").match(/,\s*([A-Z]{2})\s*$/)?.[1] || "").toUpperCase()).filter(code => /^[A-Z]{2}$/.test(code)))];
  const countryCode = String(trip.countryCode || (countries.length === 1 ? countries[0] : "")).toUpperCase();
  const requested = String(trip.destinationTimeZone || trip.timeZone || object(object(snapshot.usefulInfo).values).timeZone || "");
  if (requested) {
    try { new Intl.DateTimeFormat("en", { timeZone: requested }).format(); return { countryCode, destinationTimeZone: requested }; } catch { /* Only validated IANA names are public clock inputs. */ }
  }
  return { countryCode, destinationTimeZone: resolveDestinationTimeZone(countryCode, String(trip.destination || "")) || "" };
}
